import * as firebase from 'firebase'

var config = {
  apiKey: "AIzaSyDyD-mfSzDOvywd7cVsSIKZ8Ao3y01R2W4",
  authDomain: "scrimmage-eb2e8.firebaseapp.com",
  databaseURL: "https://scrimmage-eb2e8.firebaseio.com",
  storageBucket: "scrimmage-eb2e8.appspot.com",
  messagingSenderId: "243795474499"
};

export const firebaseRef = firebase.initializeApp(config);



// WEBPACK FOOTER //
// ../utils/firebase.js